import * as React from "react";

import ReactMapboxGl from "react-mapbox-gl";
import { styled } from "../../ui/theme";
import "mapbox-gl/dist/mapbox-gl.css";
import { Style, FitBoundsOptions } from "mapbox-gl";
import Mobile from "./Mobile";
import { Map } from "mapbox-gl";
const TOKEN = "pk.eyJ1Ijoic3BhdGlhbHgiLCJhIjoiY2puYTgwYzNrNGEzbTNxcXZybTd5cDc1NiJ9.vK4YU6knFBlZ9A0lO9f02w";

const RMap = ReactMapboxGl({
  accessToken: TOKEN
});

export interface Props {
  children?: React.ReactNode;

  fitBounds?: [[number, number], [number, number]];
  fitBoundOptions: FitBoundsOptions;
  onMoveEnd?: (map: any) => void;
}
//"mapbox://styles/spatialx/ck17ugcec09ep1co5nzmtju2e"
export default function DagenMap({ fitBounds, children, fitBoundOptions, onMoveEnd }: Props) {
  return (
    <Container>
      <RMap
        style={empty}
        fitBounds={fitBounds}
        fitBoundsOptions={fitBoundOptions}
        containerStyle={{
          width: "100%",
          height: "100%"
        }}
        onResize={(m: Map) => {
          m.fitBounds(fitBounds, fitBoundOptions);
        }}
      >
        <>
          {children}
          <Mobile />
        </>
      </RMap>
    </Container>
  );
}

const Container = styled.div`
  position: relative;
  width: 100%;
  flex-grow: 1;
  overflow: hidden;
`;

const empty: Style = {
  version: 8,
  name: "blank",
  sprite: "mapbox://sprites/mapbox/light-v9",
  glyphs: "mapbox://fonts/mapbox/{fontstack}/{range}.pbf",
  sources: {
    PDOK_LuFo: {
      type: "raster",
      tiles: ["https://geodata.nationaalgeoregister.nl/luchtfoto/rgb/wmts/Actueel_ortho25/EPSG:3857/{z}/{x}/{y}.jpeg"],
      tileSize: 256
    }
  },
  layers: [
    {
      id: "background",
      type: "background",
      paint: {
        "background-color": "hsl(0,0%,100%)"
      }
    }
  ]
};
